function resourceAction(resourceName, params, overwrite, formatData) {
    return async ({commit, state}) => {
        if (
            state.resources[resourceName] === undefined
            || state.resources[resourceName] === null
            || overwrite
        ) {
            const remoteResource = require(`../remote/_r_${resourceName}`).default;

            let resourceData = await remoteResource(params ? params(state) : null);
            if(resourceData.hasOwnProperty('book_me_host_code')){
                commit('set_book_me_host_code', resourceData['book_me_host_code']);
                commit('set_coupon_response', resourceData['book_me_host_message']);
            }
            if(resourceData.hasOwnProperty('do_not_show_price_on_checkout')){
                commit('set_do_not_show_price_on_checkout', resourceData['do_not_show_price_on_checkout']);
            }
            if(resourceData.hasOwnProperty('skip_checkout')){
                commit('set_skip_checkout', resourceData['skip_checkout']);
            }
            if (formatData) {
                resourceData = formatData(resourceData);
            } else {
                resourceData = {[resourceName]: resourceData};
            }
            for (let res in resourceData) {
                commit('set_resource', {name: res, value: resourceData[res]});
            }


        }
        return state.resources[resourceName];

    }
}

function makeResourceActions(resources) {
    const actions = {};
    for (let res in resources) {
        actions['load__' + res] = resourceAction(res, resources[res][0], resources[res][1], resources[res][2])
    }
    return actions;
}

function normalizeResources(resources) {
    const res = {
        state  : {},
        actions: {}
    }
    for (let name in resources) {
        const resourceData = resources[name] || {value: null};
        res.state[name] = resourceData.__remote ? resourceData : (
            resourceData.value === undefined ? null : resourceData.value);
        if (resourceData.__remote) {
            res.actions['load__' + name] = resourceAction(name, resourceData.query, true, resourceData.process)
        }
    }

    return res;
}


export {resourceAction, makeResourceActions, normalizeResources};
